import * as PIXI from "pixi.js";
import { loadAll } from "./sound-loader";

let _assetPack: AssetPack = null as any;
export function getPack(): AssetPack {
  return _assetPack;
}

export class AssetLoader {
  public manifest: Manifest;
  constructor() {
    this.manifest = {
      sounds: [],
      textures: [],
      datas: []
    };
  }

  addTexture(name: string, src: string): void {
    this.manifest.textures.push({ name: name, src: src });
  }

  addData(name: string, src: string): void {
    this.manifest.datas.push({ name: name, src: src });
  }

  addSound(name: string, src: string[]): void {
    this.manifest.sounds.push({ name: name, src: src });
  }

  load(): Promise<AssetPack> {
    var soundsPromise = loadAll(this.manifest.sounds);
    var datasPromise = pixiLoad<any>(this.manifest.datas, "data");
    var imagesPromise = pixiLoad<PIXI.Texture>(
      this.manifest.textures,
      "texture"
    );

    return new Promise((resolve, reject) => {
      Promise.all([soundsPromise, datasPromise, imagesPromise]).then(items => {
        var assetPack = { sound: {}, texture: {}, data: {} };
        items.forEach(item => {
          switch (item.type) {
            case "data": {
              assetPack.data = item.data;
              break;
            }
            case "texture": {
              assetPack.texture = item.data;
              break;
            }
            case "sound": {
              assetPack.sound = item.data;
              break;
            }
          }
        });
        _assetPack = assetPack;
        resolve(assetPack);
      });
    });
  }
}

function pixiLoad<T>(
  items: any,
  attr: string
): Promise<Assets<Partial<Record<string, T>>>> {
  const loader = new PIXI.Loader();
  items.forEach((data: any) => {
    loader.add(data.name, data.src);
  });
  return new Promise((resolve, reject) => {
    loader.load((_, resources) => {
      for (const key in resources) {
        if (resources.hasOwnProperty(key)) {
          resources[key] = (resources as any)[key][attr];
        }
      }
      resolve({ type: attr, data: resources as any });
    });
  });
}

export interface AssetPack {
  sound: Partial<Record<string, Howl>>;
  texture: Partial<Record<string, PIXI.Texture>>;
  data: Partial<Record<string, any>>;
}

export interface Manifest {
  sounds: SoundDef[];
  textures: TextureDef[];
  datas: DataDef[];
}

export interface SoundDef {
  name: string;
  src: string[];
}

export interface TextureDef {
  name: string;
  src: string;
}

export interface DataDef {
  name: string;
  src: string;
}

export interface Assets<T> {
  type: string;
  data: T;
}
